'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
exports['default'] = AjaxReq;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _xhr = require('xhr');

var _xhr2 = _interopRequireDefault(_xhr);

function AjaxReq(url, reqContent) {
  var method = arguments.length <= 2 || arguments[2] === undefined ? 'POST' : arguments[2];

  return new Promise(function (resolve, reject) {
    (0, _xhr2['default'])({
      url: url,
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      method: method,
      body: reqContent
    }, function (err, resp, body) {
      // console.log('err', err);
      // console.log('resp', resp);
      // console.log('body', body);
      if (resp.statusCode === 200) {
        resolve(body);
      } else {
        reject(new Error(err));
      }
    });
  });
}

module.exports = exports['default'];
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi9Vc2Vycy9iYWJlL1dvcmsvdG91cmhla2xhLnVsdHJhbm9pci5jb20vYXNzZXRzL3NjcmlwdHMvbW9kdWxlcy9hamF4UmVxdWVzdC5qcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7OztxQkFFd0IsT0FBTzs7OzttQkFGZixLQUFLOzs7O0FBRU4sU0FBUyxPQUFPLENBQUMsR0FBRyxFQUFFLFVBQVUsRUFBaUI7TUFBZixNQUFNLHlEQUFDLE1BQU07O0FBQzdELFNBQU8sSUFBSSxPQUFPLENBQUMsVUFBQyxPQUFPLEVBQUUsTUFBTSxFQUFHO0FBQ3JDLDBCQUFJO0FBQ1UsU0FBRyxFQUFFLEdBQUc7QUFDUixhQUFPLEVBQUMsRUFBQyxjQUFjLEVBQUUsbUNBQW1DLEVBQUM7QUFDN0QsWUFBTSxFQUFDLE1BQU07QUFDYixVQUFJLEVBQUUsVUFBVTtLQUNuQixFQUNHLFVBQUMsR0FBRyxFQUFFLElBQUksRUFBRSxJQUFJLEVBQUs7Ozs7QUFJakIsVUFBSSxJQUFJLENBQUMsVUFBVSxLQUFLLEdBQUcsRUFBRTtBQUMxQixlQUFPLENBQUMsSUFBSSxDQUFDLENBQUM7T0FDaEIsTUFBTTtBQUNKLGNBQU0sQ0FBQyxJQUFJLEtBQUssQ0FBQyxHQUFHLENBQUMsQ0FBQyxDQUFDO09BQzNCO0tBQ0YsQ0FDUixDQUFBO0dBQ1AsQ0FBQyxDQUFBO0NBQ0YiLCJmaWxlIjoiL1VzZXJzL2JhYmUvV29yay90b3VyaGVrbGEudWx0cmFub2lyLmNvbS9hc3NldHMvc2NyaXB0cy9tb2R1bGVzL2FqYXhSZXF1ZXN0LmpzIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHhociBmcm9tICd4aHInO1xuXG5leHBvcnQgZGVmYXVsdCBmdW5jdGlvbiBBamF4UmVxKHVybCwgcmVxQ29udGVudCwgbWV0aG9kPSdQT1NUJykge1xuXHRyZXR1cm4gbmV3IFByb21pc2UoKHJlc29sdmUsIHJlamVjdCk9Pntcblx0XHR4aHIoe1xuICAgICAgICAgICAgICAgIHVybDogdXJsXG4gICAgICAgICAgICAsICAgaGVhZGVyczp7XCJDb250ZW50LVR5cGVcIjogXCJhcHBsaWNhdGlvbi94LXd3dy1mb3JtLXVybGVuY29kZWRcIn1cbiAgICAgICAgICAgICwgICBtZXRob2Q6bWV0aG9kXG4gICAgICAgICAgICAsICAgYm9keTogcmVxQ29udGVudFxuICAgICAgICAgICAgfVxuICAgICAgICAgICAgLCAgIChlcnIsIHJlc3AsIGJvZHkpID0+IHtcbiAgICAgICAgICAgICAgICAgICAgLy8gY29uc29sZS5sb2coJ2VycicsIGVycik7XG4gICAgICAgICAgICAgICAgICAgIC8vIGNvbnNvbGUubG9nKCdyZXNwJywgcmVzcCk7XG4gICAgICAgICAgICAgICAgICAgIC8vIGNvbnNvbGUubG9nKCdib2R5JywgYm9keSk7XG4gICAgICAgICAgICAgICAgICAgIGlmIChyZXNwLnN0YXR1c0NvZGUgPT09IDIwMCkge1xuICAgICAgICAgICAgICAgICAgICAgICByZXNvbHZlKGJvZHkpO1xuICAgICAgICAgICAgICAgICAgIFx0fSBlbHNlIHtcbiAgICAgICAgICAgICAgICAgICAgICAgcmVqZWN0KG5ldyBFcnJvcihlcnIpKTtcbiAgICAgICAgICAgICAgICAgXHR9XG4gICAgICAgICAgICAgICAgfVxuICAgICAgICApXG5cdH0pXG59Il19